import { Component, ElementRef, Host, NO_ERRORS_SCHEMA, QueryList, ViewChildren } from '@angular/core';
import { DeviceBaseComponent } from '../../device-base/device-base.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-yealink-exp43',
  standalone: true,
  templateUrl: './yealink-exp43.component.html',
  styleUrls: ['../../device-base/device-base.component.scss'],
  imports: [NgClass],
  schemas: [NO_ERRORS_SCHEMA],
})
export class YealinkExp43Component {
  @ViewChildren('lineKeyButton') lineKeyButtons!: QueryList<ElementRef>;

  constructor(@Host() public base: DeviceBaseComponent) {}

  getLineKeyButtons(): ElementRef<SVGPathElement>[] {
    return this.lineKeyButtons.toArray();
  }
}
